import {
  _primaryControls,
  _selectorControls,
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  description,
  material_code,
  amount,
  withdrawn_amount,
  purchased_amount,
  unit,
  heat_treatment,
  surface_treatment,
  target_date,
  remarks,
  leadTime,
} from '@/table/Job/SubJob/base';
import useSubJob from '@/use/useSubJob';

const {
  translateSubJobStatus, statusClassMap,
} = useSubJob();

export function getStatus(
  overallStatus: string,
  computedStatus: string,
  processStatus: string | null = null,
  assemblyStatus: string | null = null,
): string {
  if (processStatus === 'QC' || computedStatus === 'QC_PASS') {
    console.log(overallStatus, computedStatus, processStatus, assemblyStatus);
    if (overallStatus === 'PENDING') return 'QC';
    if (overallStatus === 'QC_PASS') {
      if (assemblyStatus !== null && assemblyStatus !== 'PENDING') return assemblyStatus;
      return 'QC_PASS';
    }
    if (overallStatus === 'QC_PROGRESS') return 'QC_PROGRESS';
    if (overallStatus === 'QC_FAIL') return 'QC_FAIL';
  }

  if (computedStatus === 'IN_PROGRESS') return 'QC';

  return computedStatus;
}

export default {
  types: {
    _primaryControls,
    _selectorControls,
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    description,
    material_code,
    amount,
    withdrawn_amount,
    purchased_amount,
    unit,
    status: {
      name: 'สถานะภาพรวม',
      width: '8rem',
      filter: (val: string, row: any) => translateSubJobStatus(getStatus(row.item.status, row.item.computed_status, row.item.process_status, row.item.assembly_status)),
      class: {
        text: (val: string, row: any) => statusClassMap(getStatus(row.item.status, row.item.computed_status, row.item.process_status, row.item.assembly_status)),
      },
    },
    heat_treatment,
    surface_treatment,
    target_date,
    remarks,
    leadTime,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    'withdrawn_amount',
    'purchased_amount',
    'unit',
    'status',
    'heat_treatment',
    'surface_treatment',
    'target_date',
  ],
};
